export default () => ({
  container: {
    borderRadius: 5,
    marginTop: 0,
    minHeight: 55,
  },
  dateTextParent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dateIcon: {
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
  parentDateRange: {
    justifyContent: 'center',
  },
});
